'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var restrictedProp = {};

exports.__exports = restrictedProp;
